import React, { Component } from 'react';
import classnames from 'classnames'
import { Formik, Form } from 'formik';
import ModalInner from '../layoutItems/modalInner';
import { withLocalize } from 'react-localize-redux';
import { Translate } from "react-localize-redux";
import { apiPost, getHostApi } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import Dropzone from 'react-dropzone';
import ReactHtmlParser from 'react-html-parser';
import { escape } from 'lodash';
import DeleteIcon from '../../img/icons/BBiconsOdstranit';
import RichTextEditor from "../common/richTextEditor";
import "./feedbackPopup.scss";

class FeedbackPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '', files: [], progress: 0, loading: false, fileSize: 0, sending: false, error: false, rejectedFiles: null
        }
    }

    updateContent(value) {
        this.setState({ content: value })
    }
    handleSubmit(values) {
        if (this.state.fileSize > 10485760) {
            this.setState({ files: [], progress: 0, errorFile: true })
        }
        else {
            this.setState({ sending: true });
            apiPost(`${getHostApi()}/api/account/feedback`, null,
                {
                    message: escape(this.state.content),
                    files: this.state.files,
                    feedbackType: values.feedback
                },
                (data) => {
                    if (data.data)
                        this.props.close();
                    else
                        this.setState({ error: true, sending: false });
                },
                _ => {
                    this.setState({ error: true, sending: false });
                }
            );
        }
    }

    uploadImageCallBack(file) {
        return new Promise(
            (resolve, reject) => {
                const reader = new FileReader();
                reader.onload = e => resolve({ data: { link: e.target.result } });
                reader.onerror = e => reject(e);
                reader.readAsDataURL(file);
            });
    }


    getFile = (files) => {
        if (files.length > 0) {
            this.setState({ progress: 0, loading: true });
            files.forEach(file => {
                this.setState({ fileName: file.name, fileType: file.type });
                const reader = new FileReader();
                reader.onerror = this.errorHandler;
                reader.onprogress = (e) => this.progressHandler(e);
                reader.onload = (e) => this.processFile(e, file);
                reader.readAsDataURL(file);
            });
        }
    }

    processFile(e, file) {
        let content = e.target.result.split("base64,")[1];
        let result = {};
        result.fileName = file.name;
        result.fileBytes = content;
        result.contentType = file.type;
        this.setState({ files: this.state.files.concat(result), fileSize: this.state.fileSize + file.size, loading: false });
    }

    getFileSize(base64) {
        var str = atob(base64);
        return str.length;
    }

    resetProgress() {
        this.setState({ progress: 0 });
    }

    progressHandler(event) {
        if (event.lengthComputable) {
            var progress = event.loaded / event.total * 100;
            this.setState({ progress: progress, loading: progress === 100 ? false : true })
        }
    }

    removeFile(fileName) {
        var file = this.state.files.filter(e => { return e.fileName === fileName })[0];
        var files = this.state.files.filter(e => { return e.fileName !== fileName });
        this.setState({ files: files, fileSize: this.state.fileSize - this.getFileSize(file.fileBytes) });
    }

    getColor = (isDragActive, isDragAccept, isDragReject) => {
        if (isDragAccept) {
            return '#2196f3';
        }
        if (isDragReject) {
            return '#ff1744';
        }
        if (isDragActive) {
            return '#00e676';
        }
        return '#ccc';
    }

    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Feedback.Title")} style={this.props.style}>
                <div className="feedback-overlay" style={{ display: this.state.sending ? "block" : "none" }}>
                </div>
                <Formik initialValues={{ feedback: 'Recommendation', files: [], message: "" }}
                    onSubmit={(values, { setSubmitting }) => this.handleSubmit(values, setSubmitting)}>
                    {({
                        values,
                        setFieldValue
                    }) => (
                        <Form>
                            <div className="ml-feedback-popup">
                                <div>
                                    <p>{this.props.translate("Feedback.Text")}</p>
                                </div>
                                <hr className="feedback-hr" />
                                <div className="feedback-selector" style={{ paddingBottom: '10px' }}>
                                    <span data-active={values.feedback === "Recommendation"}
                                        onClick={() => setFieldValue("feedback", 'Recommendation')}>{this.props.translate("Feedback.Option.Recommendation")}</span>
                                    <span className="middle" data-active={values.feedback === "NotWork"}
                                        onClick={() => setFieldValue("feedback", 'NotWork')}>{this.props.translate("Feedback.Option.NotWork")}</span>
                                    <span data-active={values.feedback === "Praise"}
                                        onClick={() => setFieldValue("feedback", 'Praise')} >{this.props.translate("Feedback.Option.Praise")}</span>
                                </div>
                                <RichTextEditor
                                    value={this.state.content}
                                    onChange={(value) => this.updateContent(value)}
                                />
                                <Dropzone accept='image/*, video/*' onDropAccepted={acceptedFiles => { setFieldValue("files", values.files.concat(acceptedFiles)); this.getFile(acceptedFiles); }}
                                    onDropRejected={rejectedFiles => { this.setState({ rejectedFiles: rejectedFiles }); }} >
                                    {({ getRootProps, getInputProps, isDragActive,
                                        isDragAccept,
                                        isDragReject }) => (
                                        <div className="container" style={{ padding: "10px 0 0 0" }}>
                                            <div
                                                {...getRootProps({
                                                    className: 'dropzone',
                                                    style: { borderColor: `${this.getColor(isDragActive, isDragAccept, isDragReject)}` }
                                                })}
                                            >
                                                <input {...getInputProps()} />
                                                <p>{ReactHtmlParser(this.props.translate("Common.DropFiles"))}</p>
                                            </div>
                                            {/*<div>
                                                <progress className="progress" value={this.state.progress} max="100"></progress>
                                            </div>*/}
                                            <div className="drop-file-error" style={{ display: this.state.fileSize > 10485760 ? "block" : "none" }} ><p style={{ color: 'red' }}>{this.props.translate("Feedback.Error.FileSize")}</p></div>
                                            {this.state.rejectedFiles && <div className="drop-file-error"><p style={{ color: 'red' }}>{this.props.translate("Feedback.Error.NotSupported")}: {this.state.rejectedFiles.map(r => r.name).join(', ')}</p></div>}
                                            <aside style={{ paddingTop: '10px' }}>
                                                <ul>{values.files.map(file => (
                                                    <li key={file.name}>
                                                        <div className="files-name">
                                                            <div className="file-name-column" >
                                                                {file.name}
                                                            </div>
                                                            <div className="file-name-remove">
                                                                <DeleteIcon className='svg-standard-fill' onClick={() => {
                                                                    this.removeFile(file.name);
                                                                    setFieldValue("files", values.files.filter(e => {
                                                                        return e.name !== file.name
                                                                    }));
                                                                }} />
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}</ul>
                                            </aside>
                                        </div>
                                    )}
                                </Dropzone>
                            </div>
                            <div style={{ display: this.state.error ? "block" : "none", textAlign: "center" }} ><p style={{ color: 'red' }}>{this.props.translate("Feedback.Error.Send")}</p></div>
                            <div className="modal-inner-buttons" style={{ marginBottom: '1em' }}>
                                <button type="submit" disabled={this.state.loading || this.state.sending || this.state.fileSize > 10485760
                                    || this.state.content.replace(/<(.|\n)*?>/g, '').trim().length === 0 || isNullOrUndefined(this.state.content)}
                                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                    <Translate id={`Common.${this.state.sending ? "Sending" : "Send"}`} />
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        );
    }
}

export default withLocalize(FeedbackPopup);